import React from "react"
import { Link } from "react-router-dom"
import Grid from "@mui/material/Grid"

// This is used for marketing our top locations. Expected placement is
// the homepage.

const BASE_URL =
  "https://res.cloudinary.com/coastline-academy/image/upload/w_200,h_200,c_fill,q_auto/location-images/"

const LOCATIONS = [
  {
    name: "California",
    image: "san-francisco-small_voctwo",
    state: "ca",
  },
  {
    name: "Colorado",
    image: "colorado-small_bisggr",
    state: "co",
  },
  {
    name: "Illinois",
    image: "illinois-small_tjd4pe",
    state: "il",
  },
  {
    name: "Indiana",
    image: "indiana-small_hfh2er",
    state: "in",
  },
  {
    name: "Missouri",
    image: "missouri_fzrhlq",
    state: "mo",
  },
  {
    name: "Nevada",
    image: "nevada-small_atdehn",
    state: "nv",
  },
  {
    name: "Pennsylvania",
    image: "pennsylvania-state-photo_gkgd3l",
    state: "pa",
  },
  {
    name: "Texas",
    image: "dallas-skyline_y5xeil",
    state: "tx",
  },
]

const TopLocations = () => {
  const renderLocation = (location) => (
    <div
      className="location-circle-image"
      style={{ backgroundImage: `url(${BASE_URL}${location.image})` }}
    >
      <Link to={`/state/${location.state}`}>{location.name}</Link>
    </div>
  )

  return (
    <Grid container spacing={5} justifyContent="center">
      {LOCATIONS.map((location) => (
        <Grid item key={location.name}>
          {renderLocation(location)}
        </Grid>
      ))}
    </Grid>
  )
}

export default TopLocations
